export { default } from './image-loader.component';
